import GoogleAnalytics from 'react-ga';

const settings = {

	SITENAME : 'Casswell Bank',
	BRAND : 'CBA',
	STRAPLINE : 'A anchitecture practice in London',
	GA_ID : false, // Analytics ID
	MANIFEST : [],
	GOOGLE_MAPS_API_KEY : '' // Maps ID
	
}



/*
	Init GA
*/

if(settings.GA_ID){
GoogleAnalytics.initialize({

    trackingId: settings.GA_ID,
    debug: true

});
}

export default settings;





// WEBPACK FOOTER //
// ./src/js/_settings.js